import React, { FC } from 'react';

import Flag from 'ui/Phone/components/Flag';
import service from 'error-handler/functions/service';

import { IPhoneNumber } from 'ui/Phone/types';

interface ICountry extends IPhoneNumber {
  activeISO?: string;
  isoChangeHandler: (props: IPhoneNumber) => void;
}

const Country: FC<ICountry> = ({ iso, name, countryCode, mask, activeISO, isoChangeHandler }): React.ReactElement => {
  return (
    <li
      onClick={() => service({ iso, name, countryCode, mask })('isoChangeHandler')(isoChangeHandler)}
      className={`select__country${iso === activeISO ? ' select__country--active' : ''}`}
    >
      <Flag code={countryCode.toLowerCase()} />

      <span className="select__country-name">{name}</span>
      <span className="select__country-iso">{iso}</span>
    </li>
  );
};

export default React.memo(Country);
